// is there a specific feature in the credit card layout we are hoping to emphasize?
export default Object.freeze({
    none: 'none',
    firstYearRewards: 'first-year-rewards',
    subsequentYearRewards: 'subsequent-year-rewards',
});

